export const callBackendAPI = async ({ body, headers, method, path }) => {
  const apiURL = `${process.env.REACT_APP_BACKEND_URL}${path}`;
  console.log("Calling API: ", apiURL);
  const response = await fetch(apiURL, {
    method,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("api_token")}`,
      "Content-Type": "application/json",
      ...headers,
    },
    body: JSON.stringify(body),
  });
  // console.log({ response });
  // console.log("---------------");
  return response.json();
};
